import { EtlJobStatus, Status } from "@api/apiClient";
import { makeAutoObservable, toJS } from "mobx";

export class EtlJobStatusStore {
  public projects: { [projectId: string]: { [modelId: string]: EtlJobStatus; }; } = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get dump() {
    return toJS(this);
  }

  hasActiveJobs = (projectId?: string): boolean => {
    if (projectId) {
      return this.activeJobsCheck(projectId);
    }

    const activeJobs = Object.keys(this.projects).some((projectId) => {
      return this.activeJobsCheck(projectId);
    });
    console.log("hasActiveJobs", activeJobs);
    return activeJobs;
  };

  completeJob = (job: EtlJobStatus) => {
    if (job?.projectId && job?.modelId) {
      if (Object.hasOwnProperty.call(this.projects, job.projectId)) {
        if (Object.hasOwnProperty.call(this.projects[job.projectId], job.modelId!)) {
          this.projects[job.projectId][job.modelId] = job;
        }
      }
    }
  };

  upsert = (jobStatus: EtlJobStatus) => {
    if (jobStatus.projectId && jobStatus.modelId) {
      if (!Object.hasOwnProperty.call(this.projects, jobStatus.projectId)) {
        this.projects[jobStatus.projectId] = {};
      }

      this.projects[jobStatus.projectId][jobStatus.modelId] = jobStatus;
    }
  };

  getModelStatus = (projectId: string, modelId: string): EtlJobStatus | undefined => {
    const jobStatuses = this.projects[projectId];
    if (jobStatuses) {
      const jobStatus = jobStatuses[modelId];
      return jobStatus;
    }
  };

  private activeJobsCheck(projectId: string): boolean {
    if (Object.hasOwnProperty.call(this.projects, projectId)) {
      return Object.keys(this.projects[projectId]).some((modelId) => {
        return this.projects[projectId][modelId]?.job?.status === Status.Inprogress ||
          this.projects[projectId][modelId]?.job?.status === Status.Pending;
      });
    }
    return false;
  }
}


